module.exports = __webpack_public_path__ + "img/image10.8b9a4e04.png";